<template>

<DialogBox :settings="settings" :disabled="!isFormValid" @save="save" @show="showDialog" @hide="hideDialog">

        <div style="position:relative" class="pa-4">

            <v-autocomplete v-model="filter.type" label="Type of Filter" :items="['Visible']" />   
            <v-combobox v-model="filter.name" label="Element Name" :items="masterNames" />   
            <v-autocomplete v-model="filter.operator" label="Operator" :items="operators.map(o=> o.name)" />   
            <v-combobox multiple chips v-model="filter.values" label="Is one of the following" :items="masterChoices" />     
        </div>
  
</DialogBox>

</template>

<script>
import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'
import LookupData from '../helpers/LookupData'
import StringHelpers from '../helpers/StringHelpers'
import Utilities from '../helpers/Utilities'
// import filterBuilder from '../ui-elements/filter-builder'
import DialogBox from '../ui-elements/DialogBox'
import ElementHelpers from '../helpers/ElementHelpers';


export default {
props:{
    settings: Object,
    elements: Array,
    filterProp: Object,
},
components:{
    'DialogBox': DialogBox

},
data() {
    return {
        filter: {
            type: 'Visible',
            name: '',
            values: [],
            operator: 'Equals'
        }

    }
},
computed: {

    transaction() {
        return this.$store.getters.transaction
    },
    masterElements() {
        // return this.$store.getters.masters[this.transaction.masterKey] || []
        return ElementHelpers.getMasters(this.transaction.masterKey)
    },
    masterNames() {
        return this.masterElements.map(o => o.name)
            .filter(i => (i != null))
            .sort()
    },

    operators() {
        return LookupData.operators()
    },

    masterChoices() {
        
        let name = this.filter.name
        if(!name)
            return []
        let masterElement = this.masterElements.find(o => o.name == name)
        if(!masterElement)
            return []

        if(masterElement.type == 'List') {
            let optionsString = masterElement.options || ''
            let options = optionsString.split(',').map(i => i.trim())
            return ['Blank', 'Non Blank', ...options]
        }

        if(masterElement.type == 'Switch' || masterElement.type == 'Checkbox') {
            return ['Yes', 'No']
        }
        
        return ['Blank', 'Non Blank']
    },

    isFormValid() {
        return this.filter.name && this.filter.values.length
    }

    
},
methods: {
    save() {
        this.$emit('save', this.filter)
    },

    showDialog() {
        if(this.filterProp) {
            this.filter = this.filterProp
        }
    },

    hideDialog() {
        setTimeout( () => { 
            this.filter = {
                type: 'Visible',
                name: '',
                values: [],
                operator: 'Equals'
            }
        }, 300)  
    }

},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// FilterEditor.vue?89111af6